import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { personalUses, professionalUses } from '../data/content';
export function AudienceSection() {
  return <section className="bg-ivory py-12 md:py-20 px-4" data-id="element-1" data-mp="s0bf1shgc1z1">
      <div className="max-w-5xl mx-auto" data-id="element-2" data-mp="ryrw1u4evctk">
        <SectionHeading title="Para ti. O para las personas que acompañas." data-id="element-3" data-mp="wzxso316zk8d" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-4" data-mp="3vhl822hjjtlm">
          <article className="flex flex-col bg-white rounded-2xl border border-terracotta/30 shadow-soft p-6 md:p-8" data-id="element-5" data-mp="3vfgsuoe6z861">
            <p className="font-sans text-[11px] font-bold uppercase tracking-wider text-terracotta-deep" data-id="element-6" data-mp="9ad6lb9qs6uv">
              Para ti
            </p>
            <p className="mt-2 font-sans text-[15px] md:text-base font-semibold text-forest" data-id="element-7" data-mp="e1lf8538zo6z">
              Una biblioteca a la que puedes volver cuando quieras:
            </p>
            <ul className="mt-3 space-y-2" data-id="element-8" data-mp="3hp4xmgmb8tao">
              {personalUses.map(use => <li key={use} className="flex items-start gap-2.5 font-sans text-[15px] md:text-base text-forest/80" data-id="element-9" data-mp="14bc3n98ou04g">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0 text-terracotta" aria-hidden="true" data-id="element-10" data-mp="zcr65hktlujp" />
                  {use}
                </li>)}
            </ul>
            <p className="mt-auto pt-5 font-serif italic text-base md:text-lg text-terracotta-deep" data-id="element-11" data-mp="qjxnda660d13">
              No necesitas saber dibujar.
            </p>
          </article>

          <article className="flex flex-col bg-sage-light rounded-2xl p-6 md:p-8" data-id="element-12" data-mp="gl83jbupkii7">
            <p className="font-sans text-[11px] font-bold uppercase tracking-wider text-sage-deep" data-id="element-13" data-mp="gnkuufmcw57x">
              Para tu práctica
            </p>
            <p className="mt-2 font-sans text-[15px] md:text-base font-semibold text-forest" data-id="element-14" data-mp="7llbvhrs6r2c">
              Para psicólogos, terapeutas, coaches, educadores, facilitadores y profesionales del
              bienestar.
            </p>
            <ul className="mt-3 space-y-2" data-id="element-15" data-mp="21zcgg2v96kqx">
              {professionalUses.map(use => <li key={use} className="flex items-start gap-2.5 font-sans text-[15px] md:text-base text-forest/80" data-id="element-16" data-mp="3vfqjknc34zib">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0 text-sage-deep" aria-hidden="true" data-id="element-17" data-mp="44p3jzn2u23q" />
                  {use}
                </li>)}
            </ul>
            <div className="mt-auto pt-5" data-id="element-18" data-mp="3qigoar20ltmk">
              <p className="font-serif text-base md:text-lg font-bold text-forest tracking-wide" data-id="element-19" data-mp="i2n8keficm6k">
                Observar → Preguntar → Escuchar
              </p>
              <p className="mt-0.5 font-sans text-[13px] text-forest/65" data-id="element-20" data-mp="mzdyrul10y5p">
                No interpretar automáticamente la obra.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>;
}